<ion-content>
  <h1>{{wfName}}</h1>
  <form class="capture-metadata-form" [formGroup]="formData" (ngSubmit)="onSubmit()">
    <ion-list>
      <ng-container formArrayName="items">
        @for (mdItem of metaData; track $index) {
          <ion-item class="metadata-item" lines="none" [formGroupName]="$index">
              <div class="field-block">
                <ion-label>{{"Name" | translate}}:</ion-label>
                <ion-input class="metadata-input" type="text" fill="outline" formControlName="name"></ion-input>
              </div>
              <div class="field-block">
                <ion-label>{{"Label" | translate}}:</ion-label>
                <ion-input type="text" fill="outline" formControlName="label"></ion-input>
              </div>
            <!-- <ion-label>{{"Type" | translate}}:</ion-label> -->
            <!-- <ion-select formControlName="type" placeholder="{{'SelectType' | translate}}">
              <ion-select-option value="text">{{"Text" | translate}}</ion-select-option>
              <ion-select-option value="number">{{"Number" | translate}}</ion-select-option>
              <ion-select-option value="date">{{"Date" | translate}}</ion-select-option>
              <ion-select-option value="boolean">{{"Boolean" | translate}}</ion-select-option>
              <ion-select-option value="list">{{"List" | translate}}</ion-select-option>
            </ion-select> -->
          </ion-item>
        }
      </ng-container>
    </ion-list>
    <div class="button-container">
      <ion-button (click)="popoverController.dismiss()">{{"Cancel" | translate}}</ion-button>
      <ion-button type="submit">{{"Save" | translate}}</ion-button>
    </div>
  </form>
  <!-- Name: {{mdItem.name}}
  Label: {{mdItem.displayName}}
  Type: {{mdItem.type}} -->
  <!-- <form class="other-methods-form" action="" (ngSubmit)="checkUserTenant()">
          <fieldset class="form-section">
            <div class="form-group form-group-lg tenant-domain-input">
              <span class="input-wrapper">
                <input class="form-control--inline width70"
                  [ngClass]="{'loading': showTenantNameSpinner}"
                  name="onelogin"
                  type="text"
                  (input)="hideErrorText($event)"
                  [(ngModel)]="userInputTenantDomain"
                  placeholder="{{'MyPrintixHome' | translate | stringular: 'Printix'}}"
                  required
                />
                <ion-spinner class="input-spinner" name="lines" [hidden]="!showTenantNameSpinner"></ion-spinner>
              </span>
              <span class="printix-url ml10 mt5 width25">.printix.net</span>

              <button
                class="btn btn-primary width40 mt30"
                type="submit"

                block
                [disabled]="!userInputTenantDomain || showTenantDoesNotExist || showTenantIsDeactivated">
                {{"Ok" | translate}}
              </button>
            </div>
          </fieldset>
        </form> -->

        <!-- <a class="btn btn-block btn-link back-button"
          role="button"
          (click)="">
          {{"Back"| translate}}
        </a> -->
</ion-content>